import { render, staticRenderFns } from "./ContainerFooter.vue?vue&type=template&id=c81b3f92&scoped=true&"
import script from "./ContainerFooter.vue?vue&type=script&lang=js&"
export * from "./ContainerFooter.vue?vue&type=script&lang=js&"
import style0 from "./ContainerFooter.vue?vue&type=style&index=0&id=c81b3f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81b3f92",
  null
  
)

export default component.exports